import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "flex flex-col flex-1 h-full bg-white",
  "data-cy": "matter-info-edit"
}
const _hoisted_2 = { class: "flex justify-between items-center pt-2 pb-3 px-4 sticky top-0 z-10 bg-white border-b border-gray-200" }
const _hoisted_3 = { class: "space-y-1 sm:px-6" }
const _hoisted_4 = { class: "text-lg font-medium leading-6 text-gray-900" }
const _hoisted_5 = { class: "flex justify-end" }
const _hoisted_6 = { class: "overflow-y-auto flex-1 h-full" }
const _hoisted_7 = { class: "p-4" }
const _hoisted_8 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2" }
const _hoisted_9 = { class: "col-span-1" }
const _hoisted_10 = { class: "col-span-1" }
const _hoisted_11 = { class: "block text-sm font-medium text-gray-700" }
const _hoisted_12 = { class: "flex items-center mt-1" }
const _hoisted_13 = {
  key: 0,
  class: "flex items-center mr-1 text-sm text-gray-700"
}
const _hoisted_14 = { class: "p-4" }
const _hoisted_15 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2" }
const _hoisted_16 = { class: "col-span-1" }
const _hoisted_17 = { class: "mt-4" }
const _hoisted_18 = {
  key: 0,
  class: "mt-4"
}
const _hoisted_19 = {
  key: 1,
  class: "mt-4"
}
const _hoisted_20 = { class: "mt-4" }
const _hoisted_21 = { class: "col-span-1" }
const _hoisted_22 = { class: "mt-4" }
const _hoisted_23 = { class: "mt-4" }
const _hoisted_24 = { class: "mt-4" }
const _hoisted_25 = { class: "p-4" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2" }
const _hoisted_27 = { class: "col-span-1" }
const _hoisted_28 = {
  key: 0,
  class: "col-span-1"
}
const _hoisted_29 = {
  key: 0,
  class: "p-4"
}
const _hoisted_30 = { class: "mt-6 ml-4 grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2" }
const _hoisted_31 = { class: "col-span-1" }
const _hoisted_32 = { class: "col-span-1" }
const _hoisted_33 = { class: "col-span-1" }
const _hoisted_34 = {
  key: 1,
  class: "p-4"
}
const _hoisted_35 = { class: "mt-6 ml-4 grid grid-cols-1 gap-x-2 gap-y-6 md:grid-cols-2" }
const _hoisted_36 = { class: "m-2 text-xs text-gray-600" }
const _hoisted_37 = {
  key: 2,
  class: "p-4",
  "data-cy": "contingency-details-edit-section"
}
const _hoisted_38 = { class: "grid grid-cols-1 gap-x-4 gap-y-6 md:grid-cols-2" }
const _hoisted_39 = { class: "col-span-1" }
const _hoisted_40 = { class: "mt-4" }
const _hoisted_41 = { class: "mt-4" }
const _hoisted_42 = { class: "mt-4" }
const _hoisted_43 = { class: "col-span-1" }
const _hoisted_44 = { class: "mt-4" }
const _hoisted_45 = { key: 2 }
const _hoisted_46 = { class: "flex flex-row w-full" }
const _hoisted_47 = {
  class: "flex-4 grid grid-cols-2 gap-4 w-full",
  "data-cy": "matter-detail"
}
const _hoisted_48 = { class: "text-base leading-loose space-y-1.5 w-full" }
const _hoisted_49 = { class: "text-sm" }
const _hoisted_50 = { class: "text-sm" }
const _hoisted_51 = { class: "text-sm" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = { class: "mr-2 text-xs text-gray-400" }
const _hoisted_54 = { class: "text-sm" }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "mr-2 text-xs text-gray-400" }
const _hoisted_57 = { class: "text-sm" }
const _hoisted_58 = { class: "text-sm" }
const _hoisted_59 = { class: "text-sm" }
const _hoisted_60 = { class: "text-base leading-loose space-y-1.5 w-full" }
const _hoisted_61 = { class: "text-sm" }
const _hoisted_62 = { class: "text-sm" }
const _hoisted_63 = { class: "text-sm" }
const _hoisted_64 = { class: "text-sm" }
const _hoisted_65 = { class: "text-base leading-loose space-y-1.5 w-full" }
const _hoisted_66 = { class: "text-sm whitespace-pre-line" }
const _hoisted_67 = { class: "text-base leading-loose space-y-1.5 w-full" }
const _hoisted_68 = {
  key: 0,
  class: "text-sm whitespace-pre-line"
}
const _hoisted_69 = {
  key: 1,
  class: "text-xs text-gray-400"
}
const _hoisted_70 = { class: "flex-1 text-right no-print" }
const _hoisted_71 = {
  key: 0,
  class: "text-base leading-loose space-y-1.5 w-full"
}
const _hoisted_72 = { class: "text-sm" }
const _hoisted_73 = { class: "text-sm" }
const _hoisted_74 = { key: 0 }
const _hoisted_75 = { class: "text-sm" }
const _hoisted_76 = { key: 1 }
const _hoisted_77 = { class: "text-sm" }
const _hoisted_78 = {
  key: 1,
  class: "text-base leading-loose space-y-1.5 w-full mt-4"
}
const _hoisted_79 = { class: "my-1 text-xs text-gray-600" }
const _hoisted_80 = { class: "text-sm" }
const _hoisted_81 = {
  key: 2,
  class: "text-base leading-loose space-y-1.5 w-full mt-4",
  "data-cy": "contingency-details-section"
}
const _hoisted_82 = { class: "py-1" }
const _hoisted_83 = {
  class: "text-sm",
  "data-cy": "contingency-case-status"
}
const _hoisted_84 = { class: "py-1" }
const _hoisted_85 = {
  class: "text-sm",
  "data-cy": "contingency-marketing-source"
}
const _hoisted_86 = { class: "py-1" }
const _hoisted_87 = {
  class: "text-sm",
  "data-cy": "contingency-expected-settlement-date"
}
const _hoisted_88 = { class: "py-1" }
const _hoisted_89 = {
  class: "text-sm",
  "data-cy": "contingency-expected-settlement-amount"
}
const _hoisted_90 = { class: "py-1" }
const _hoisted_91 = {
  class: "text-sm",
  "data-cy": "contingency-expected-case-costs"
}
const _hoisted_92 = { class: "py-1" }
const _hoisted_93 = {
  class: "text-sm",
  "data-cy": "contingency-settlement-date"
}

import { ref, reactive, computed, onMounted, onBeforeUnmount, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useMeStore } from '@/services/UserService/useMeStore';
import useClientMatterStore from '@/services/useClientMatterStore';
import MatterService from '@/services/MatterService';
import { useSnackbarHandler } from '@/composables/useSnackbarHandler';
import {
  prepareCustomFieldsArray,
  prepareMatterUpdatePayload,
  toDateInputValue,
} from '@/services/matterPayloadUtils';
import {
  fetchContingencyOptions,
  getCaseStatusLabel,
  getMarketingSourceLabel,
} from '@/services/constants/contingencyOptions';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import LlTextField from '@/components/LlTextField.vue';
import LlTextarea from '@/components/LlTextarea.vue';
import LlSelect from '@/components/LlSelect.vue';
import LlConfirmationDialog from '@/components/LlConfirmationDialog.vue';

const matterTagInfo = 'To set up Practice Areas, go to Settings > Practice Areas';

// Computed

export default /*@__PURE__*/_defineComponent({
  __name: 'MatterInfo',
  props: {
  stateParams: { type: Object, required: false },
  state: { type: Object, required: false },
  rootScope: { type: Object, required: false },
  alerts: { type: Object, required: false },
  matterTagsService: { type: Object, required: false },
},
  setup(__props) {

const props = __props;

// Pinia stores
const meStore = useMeStore();
const { me } = storeToRefs(meStore);
const clientMatterStore = useClientMatterStore();
const { handleError, handleSuccess } = useSnackbarHandler();

// Refs
const formRef = ref(null);
const confirmDialogRef = ref(null);

// UI state
const uiState = reactive({
  initialLoading: true,
  isEditing: false,
  saving: false,
});

// JSON snapshot of formState taken when edit begins, used to detect real edits
// for the unsaved-changes route guard (mirrors Angular's infoForm.$dirty).
let editBaseline = null;

// The loaded matter (full object; reassigned wholesale on load to avoid leaks)
const matter = ref({});
// Editable clone of the matter
const formState = ref({});

// Custom fields
const customFields = ref([]);
const editCustomFields = ref([]);

// Which delete/archive/activate actions are available
const enable = reactive({
  delete: false,
  archive: false,
  activate: false,
  editMatterInfo: true,
});

// Matter tag dropdown options
const matterTags = ref([]);

// Contingency dropdown options
const caseStatusOptions = ref([]);
const marketingSourceOptions = ref([]);

// Origination step-down options
const originationStepDownOptions = [
  { id: false, label: 'Enable' },
  { id: true, label: 'Disable' },
];

// Snapshot of persisted origination fields at edit start (for dirty detection)
let originalOriginationSnapshot = null;

// Confirmation dialog content
const confirmDialog = reactive({
  title: '',
  message: '',
  confirmText: 'OK',
});

// Route change listener cleanup
let deactivateRouteChange = null;

const matterId = computed(() => props.stateParams?.matterId);

const labels = computed(() => me.value?.company?.settings?.labels || {});

const requireMatterTag = computed(
  () => !!me.value?.company?.settings?.requireMatterTag,
);

const showOriginationSettings = computed(
  () => !!me.value?.company?.settings?.report?.originationStepDownPeriodInMonths,
);

const isContingency = computed(
  () =>
    (uiState.isEditing ? formState.value : matter.value)?.billing?.type ===
    'contingency',
);

const isInvalidStepDownPeriod = computed(() => {
  const value = formState.value?.billing?.originationStepDownPeriodInMonths;
  if (value == null || value === '') return false;
  const num = Number(value);
  return Number.isNaN(num) || num < 1;
});

const openedErrorMessages = computed(() => {
  if (!formState.value.opened) return ['Date Opened is required'];
  if (isInvalidDate(formState.value.opened)) return ['Please enter a valid date'];
  return [];
});

const hasValidationErrors = computed(() => {
  // Date Opened is required
  if (!formState.value.opened) return true;
  if (hasInvalidDates()) return true;
  if (hasInvalidAmounts()) return true;
  if (isInvalidStepDownPeriod.value) return true;
  return false;
});

// Lifecycle
onMounted(async () => {
  try {
    await meStore.getMe();
    await Promise.all([loadMatterData(), loadCustomFields(), loadMatterTags()]);
    await loadMatterStats();
    preloadContingencyOptions();

    // Warn about unsaved edits on route change (mirrors Angular directive)
    if (props.rootScope) {
      deactivateRouteChange = props.rootScope.$on(
        '$stateChangeStart',
        (event) => {
          if (uiState.isEditing && isFormDirty()) {
            if (props.alerts) {
              props.alerts.warning(
                'You have unsaved changes. Save or undo changes first.',
              );
            }
            event.preventDefault();
          }
        },
      );
    }
  } catch (error) {
    handleError(error);
  } finally {
    uiState.initialLoading = false;
  }
});

// Guard against stale component remounting: if matterId changes (e.g., during
// a rapid Matter A -> B transition), reload data fresh.
watch(
  () => props.stateParams?.matterId,
  async (newMatterId, oldMatterId) => {
    if (newMatterId && newMatterId !== oldMatterId && !uiState.initialLoading) {
      try {
        uiState.initialLoading = true;
        uiState.isEditing = false;
        await Promise.all([
          loadMatterData(),
          loadCustomFields(),
          loadMatterTags(),
        ]);
        await loadMatterStats();
        preloadContingencyOptions();
      } catch (error) {
        handleError(error);
      } finally {
        uiState.initialLoading = false;
      }
    }
  },
);

onBeforeUnmount(() => {
  if (deactivateRouteChange) {
    deactivateRouteChange();
  }
});

// Methods
function isActiveMatterRoute(expectedMatterId) {
  return String(props.stateParams?.matterId) === String(expectedMatterId);
}

async function loadMatterData() {
  const id = matterId.value;
  if (!id) return;
  const data = await clientMatterStore.getMatterById(id, true);

  // Ignore stale response if the user switched matters while in flight.
  if (!isActiveMatterRoute(id)) return;

  // Reassign wholesale so no property from a previously-viewed matter leaks in.
  const fresh = { ...data };
  fresh.custom = data.custom ? { ...data.custom } : {};
  fresh.billing = data.billing ? { ...data.billing } : {};

  // Mirror Angular MatterInfoCtrl.setUpOriginationSettings: default the
  // step-down period/start for display when the company has origination on.
  if (showOriginationSettings.value) {
    fresh.billing.originationStepDownPeriodInMonths =
      fresh.billing.originationStepDownPeriodInMonths ||
      me.value.company.settings.report.originationStepDownPeriodInMonths;
    fresh.billing.originationStepDownStart =
      fresh.billing.originationStepDownStart || fresh.opened;
  }

  matter.value = fresh;
}

async function loadCustomFields() {
  const id = matterId.value;
  if (!id) return;
  const data = await MatterService.getCustomFields(id);

  // Ignore stale response if the user switched matters while in flight.
  if (!isActiveMatterRoute(id)) return;

  if (data) {
    customFields.value = data.customFields.map((cf) => ({
      id: cf.customField.id,
      value: cf.value,
      type: cf.customField.type,
      label: cf.customField.name,
      textValue: cf.textValue,
      numberValue: cf.numberValue,
      enumValueId: cf.enumValue?.id,
      enumOptions: cf.customField.enumOptions || [],
    }));
  } else {
    customFields.value = [];
  }
}

async function loadMatterTags() {
  if (!props.matterTagsService?.getMatterTags) return;
  try {
    const tags = await props.matterTagsService.getMatterTags();
    matterTags.value = tags || [];
  } catch (error) {
    // Non-fatal: the dropdown just stays empty.
    handleError(error);
  }
}

async function loadMatterStats() {
  const id = matterId.value;
  if (!id) return;
  try {
    const stats = await clientMatterStore.getMatterStats(id);
    if (!isActiveMatterRoute(id)) return;
    enable.delete = !!stats?.deletable;
    enable.archive = !!matter.value.active;
    enable.activate = !matter.value.active;
    enable.editMatterInfo = !matter.value.isSecondarySplitMatter;
  } catch (error) {
    handleError(error);
  }
}

function preloadContingencyOptions() {
  if (matter.value?.billing?.type !== 'contingency') return;
  fetchContingencyOptions()
    .then(({ caseStatuses, marketingSources }) => {
      caseStatusOptions.value = caseStatuses;
      marketingSourceOptions.value = marketingSources;
    })
    .catch(() => {
      // Funnel through the shared handler with a safe, generic message so raw
      // error details aren't surfaced and error reporting stays consistent.
      handleError(
        'Failed to load contingency field options. Please refresh the page.',
      );
    });
}

function startEditing() {
  const clone = JSON.parse(JSON.stringify(matter.value));
  clone.custom = clone.custom || {};
  clone.billing = clone.billing || {};
  clone.opened = toDateInputValue(clone.opened);

  if (showOriginationSettings.value) {
    // Snapshot persisted origination fields BEFORE UI mutations
    originalOriginationSnapshot = {
      originationStepDownDisabled:
        clone.billing.originationStepDownDisabled ?? null,
      originationStepDownPeriodInMonths:
        clone.billing.originationStepDownPeriodInMonths ?? null,
      originationStepDownStart:
        toDateInputValue(clone.billing.originationStepDownStart) || null,
    };

    clone.billing.originationStepDownStatus =
      originationStepDownOptions.find(
        (opt) => opt.id === clone.billing.originationStepDownDisabled,
      ) || originationStepDownOptions[0];
    clone.billing.originationStepDownStart = toDateInputValue(
      clone.billing.originationStepDownStart,
    );
    clone.billing.originationStepDownDisabled =
      clone.billing.originationStepDownStatus.id;
  }

  if (clone.billing.type === 'contingency') {
    clone.expectedSettlementDate = toDateInputValue(clone.expectedSettlementDate);
    clone.settlementDate = toDateInputValue(clone.settlementDate);
    // Load dropdown options for editing
    loadContingencyOptions();
  }

  editCustomFields.value = JSON.parse(JSON.stringify(customFields.value));

  formState.value = clone;
  editBaseline = snapshotEditState();
  uiState.isEditing = true;
}

// Serializes everything editable — matter fields AND custom fields — so the
// unsaved-changes guard notices edits to either. Mirrors Angular's
// infoForm.$dirty, which tracked all form inputs including custom fields.
function snapshotEditState() {
  return JSON.stringify({
    form: formState.value,
    customFields: editCustomFields.value,
  });
}

// True when the user has changed anything since entering edit mode.
function isFormDirty() {
  if (editBaseline == null) return false;
  return editBaseline !== snapshotEditState();
}

function loadContingencyOptions() {
  fetchContingencyOptions()
    .then(({ caseStatuses, marketingSources }) => {
      caseStatusOptions.value = caseStatuses;
      marketingSourceOptions.value = marketingSources;
    })
    .catch(() => {
      // Funnel through the shared handler with a safe, generic message so raw
      // error details aren't surfaced and error reporting stays consistent.
      handleError(
        'Failed to load contingency field options. Please refresh the page.',
      );
    });
}

function cancelEdit() {
  uiState.isEditing = false;
  editBaseline = null;
}

function originationStepDownChange() {
  formState.value.billing.originationStepDownDisabled =
    formState.value.billing.originationStepDownStatus?.id;
}

// Validation helpers (mirror Angular directive)
function isInvalidDate(value) {
  if (value == null || value === '') return false;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime());
}

function isInvalidAmount(value) {
  if (value == null || value === '') return false;
  const num = Number(value);
  return Number.isNaN(num) || num < 0;
}

function hasInvalidDates() {
  const fs = formState.value;
  const stepDownEnabled =
    showOriginationSettings.value && !fs.billing?.originationStepDownDisabled;
  const invalidStepDownDate =
    stepDownEnabled && isInvalidDate(fs.billing?.originationStepDownStart);
  return (
    isInvalidDate(fs.opened) ||
    invalidStepDownDate ||
    (fs.billing?.type === 'contingency' &&
      (isInvalidDate(fs.expectedSettlementDate) ||
        isInvalidDate(fs.settlementDate)))
  );
}

function hasInvalidAmounts() {
  if (formState.value.billing?.type !== 'contingency') return false;
  return (
    isInvalidAmount(formState.value.expectedSettlementAmount) ||
    isInvalidAmount(formState.value.expectedCaseCosts)
  );
}

async function save() {
  if (hasValidationErrors.value) return;

  uiState.saving = true;
  try {
    const id = matterId.value;

    // Persist custom fields first (matches Angular save ordering).
    if (editCustomFields.value.length) {
      await MatterService.updateCustomFields(
        id,
        prepareCustomFieldsArray(editCustomFields.value),
      );
    }

    // Build the matter payload from a clone so formState stays intact on failure.
    const payloadSource = JSON.parse(JSON.stringify(formState.value));
    const payload = prepareMatterUpdatePayload(payloadSource);

    // Origination step-down: only persist when the user actually changed it,
    // otherwise omit the fields so the server keeps the stored values
    // (mirrors ClientInfo.vue's deliberate omit-when-unchanged behavior).
    if (payload.billing) {
      delete payload.billing.originationStepDownStatus;
      if (showOriginationSettings.value) {
        const currentSnapshot = {
          originationStepDownDisabled:
            formState.value.billing?.originationStepDownDisabled ?? null,
          originationStepDownPeriodInMonths:
            formState.value.billing?.originationStepDownPeriodInMonths ?? null,
          originationStepDownStart:
            formState.value.billing?.originationStepDownStart || null,
        };
        const originationChanged =
          JSON.stringify(originalOriginationSnapshot) !==
          JSON.stringify(currentSnapshot);
        if (!originationChanged) {
          delete payload.billing.originationStepDownDisabled;
          delete payload.billing.originationStepDownPeriodInMonths;
          delete payload.billing.originationStepDownStart;
        }
      }
    }

    const saved = await clientMatterStore.updateMatter({ id, update: payload });

    // Defensive: null means the user navigated away before the response arrived.
    if (!saved) return;

    // Reload custom fields (server may normalize values)
    if (editCustomFields.value.length) {
      await loadCustomFields();
    }

    applyLoadedMatter(saved);
    handleSuccess('Matter details updated!');
    uiState.isEditing = false;
    editBaseline = null;
  } catch (error) {
    handleError(error);
  } finally {
    uiState.saving = false;
  }
}

function applyLoadedMatter(data) {
  const fresh = { ...data };
  fresh.custom = data.custom ? { ...data.custom } : {};
  fresh.billing = data.billing ? { ...data.billing } : {};
  if (showOriginationSettings.value) {
    fresh.billing.originationStepDownPeriodInMonths =
      fresh.billing.originationStepDownPeriodInMonths ||
      me.value.company.settings.report.originationStepDownPeriodInMonths;
    fresh.billing.originationStepDownStart =
      fresh.billing.originationStepDownStart || fresh.opened;
  }
  matter.value = fresh;
  enable.archive = !!fresh.active;
  enable.activate = !fresh.active;
  enable.editMatterInfo = !fresh.isSecondarySplitMatter;
}

// --- Delete / Archive / Activate actions ---

async function confirmDelete() {
  const term = me.value?.terms?.matter || 'matter';
  confirmDialog.title = `Delete ${term}?`;
  confirmDialog.message = `Do you want to delete this ${term}?\n\nThere is no activity (time entries, invoices etc) recorded for the ${term} but note that you can't undo it.`;
  confirmDialog.confirmText = 'Delete';
  const confirmed = await confirmDialogRef.value.open();
  if (!confirmed) return;

  uiState.saving = true;
  try {
    const id = matterId.value;
    await clientMatterStore.deleteMatter(id);
    handleSuccess(`The ${term} was deleted`);
    goToTopLevelRoute();
  } catch (error) {
    handleError(error);
  } finally {
    uiState.saving = false;
  }
}

async function confirmArchive() {
  const term = me.value?.terms?.matter || 'matter';
  confirmDialog.title = `Archive ${term}?`;
  confirmDialog.message = `Do you want to archive this ${term}?\n\nArchiving the ${term} will hide it from all users and hide any unbilled time or expenses from some pages. You can easily restore the ${term} from here if you need it again.`;
  confirmDialog.confirmText = 'Archive';
  const confirmed = await confirmDialogRef.value.open();
  if (!confirmed) return;
  await changeStatus(
    false,
    `The ${term} was archived. You can find it on the lists by selecting 'Show Archived'.`,
  );
}

async function restore() {
  const term = me.value?.terms?.matter || 'matter';
  await changeStatus(true, `The ${term} was restored.`);
}

async function changeStatus(active, confirmation) {
  uiState.saving = true;
  try {
    const id = matterId.value;
    const saved = await clientMatterStore.updateMatter({
      id,
      update: { active },
    });
    if (!saved) return;
    applyLoadedMatter(saved);
    handleSuccess(confirmation);
    // Refresh the Angular wrapper (summary/tabs) so its matter state stays in sync.
    if (props.state?.reload) {
      props.state.reload();
    }
  } catch (error) {
    handleError(error);
  } finally {
    uiState.saving = false;
  }
}

function goToTopLevelRoute() {
  // e.g. 'clients.client.matter.info' -> 'clients'; 'matters-next...' -> 'matters-next'
  const current = props.state?.current?.name;
  if (current && props.state?.go) {
    props.state.go(current.split('.')[0]);
  }
}

// Display helpers
function customField(key) {
  const value = matter.value?.custom?.[key];
  return value != null && value !== '' ? value : '-';
}

function formatDateDisplay(dateString) {
  if (!dateString) return '-';
  const date = new Date(dateString);
  if (Number.isNaN(date.getTime())) return '-';
  return new Intl.DateTimeFormat('default', {
    year: '2-digit',
    month: '2-digit',
    day: '2-digit',
  }).format(date);
}

function formatCurrency(value) {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
  }).format(value);
}

return (_ctx: any,_cache: any) => {
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_form = _resolveComponent("v-form")!

  return (uiState.initialLoading)
    ? (_openBlock(), _createBlock(_component_v_container, {
        key: 0,
        class: "pa-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_skeleton_loader, { type: "heading, text@3, divider, text@6, divider, text@4" })
        ]),
        _: 1
      }))
    : (uiState.isEditing)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(matter.value.client && matter.value.client.label), 1)
            ]),
            _createElementVNode("div", _hoisted_5, [
              _withDirectives(_createVNode(LlSecondaryButton, {
                onClick: cancelEdit,
                class: "py-2 px-4"
              }, {
                default: _withCtx(() => [...(_cache[22] || (_cache[22] = [
                  _createTextVNode(" Cancel ", -1)
                ]))]),
                _: 1
              }, 512), [
                [_vShow, !uiState.saving]
              ]),
              _withDirectives(_createVNode(LlSecondaryButton, {
                color: "primary",
                disabled: uiState.saving || hasValidationErrors.value,
                onClick: save,
                class: "ml-3",
                "data-cy": "matter-info-update"
              }, {
                default: _withCtx(() => [...(_cache[23] || (_cache[23] = [
                  _createTextVNode(" Update ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]), [
                [_vShow, !uiState.saving]
              ]),
              _withDirectives(_createVNode(_component_v_progress_circular, {
                indeterminate: "",
                size: "24",
                width: "2"
              }, null, 512), [
                [_vShow, uiState.saving]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_form, {
              ref_key: "formRef",
              ref: formRef,
              class: "flex flex-col flex-1"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("div", _hoisted_9, [
                      _createVNode(LlTextField, {
                        modelValue: formState.value.name,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formState.value.name) = $event)),
                        label: `${_unref(me).terms && _unref(me).terms.Matter} Name`,
                        disabled: !enable.editMatterInfo,
                        "error-messages": !formState.value.name ? ['A name is required'] : []
                      }, null, 8, ["modelValue", "label", "disabled", "error-messages"])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(me).terms && _unref(me).terms.Matter) + " ID ", 1),
                      _createElementVNode("div", _hoisted_12, [
                        (matter.value.client && matter.value.client.reference)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                              _createElementVNode("span", null, _toDisplayString(matter.value.client.reference), 1),
                              _cache[24] || (_cache[24] = _createElementVNode("span", null, "-", -1))
                            ]))
                          : _createCommentVNode("", true),
                        _createVNode(LlTextField, {
                          modelValue: formState.value.reference,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formState.value.reference) = $event)),
                          disabled: !enable.editMatterInfo,
                          placeholder: "- Optional Id/Number -",
                          "hide-details": "",
                          class: "flex-1"
                        }, null, 8, ["modelValue", "disabled"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, [
                      _cache[25] || (_cache[25] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Internal ", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(LlTextField, {
                          modelValue: formState.value.opened,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formState.value.opened) = $event)),
                          label: "Date Opened",
                          type: "date",
                          "is-required": "",
                          "error-messages": openedErrorMessages.value
                        }, null, 8, ["modelValue", "error-messages"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createVNode(LlSelect, {
                          modelValue: formState.value.matterTag,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formState.value.matterTag) = $event)),
                          items: matterTags.value,
                          "item-title": "label",
                          "item-value": "id",
                          label: _unref(me).terms && _unref(me).terms.MatterTag,
                          info: matterTagInfo,
                          clearable: !requireMatterTag.value,
                          "hide-details": ""
                        }, null, 8, ["modelValue", "items", "label", "clearable"])
                      ]),
                      (labels.value.custom1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.custom.department,
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formState.value.custom.department) = $event)),
                              label: _unref(me).terms && _unref(me).terms.Custom1
                            }, null, 8, ["modelValue", "label"])
                          ]))
                        : _createCommentVNode("", true),
                      (labels.value.custom2)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.custom.practiceArea,
                              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formState.value.custom.practiceArea) = $event)),
                              label: _unref(me).terms && _unref(me).terms.Custom2
                            }, null, 8, ["modelValue", "label"])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(LlTextField, {
                          modelValue: formState.value.custom.referralSource,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formState.value.custom.referralSource) = $event)),
                          label: "Referral Source(s)"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_21, [
                      _cache[26] || (_cache[26] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Conflict Check Data ", -1)),
                      _cache[27] || (_cache[27] = _createElementVNode("p", { class: "text-sm text-gray-500" }, " Note that you can add multiple names to these fields. We recommend separating by \";\" if you do. ", -1)),
                      _createElementVNode("div", null, [
                        _createVNode(LlTextarea, {
                          modelValue: formState.value.custom.adverse,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formState.value.custom.adverse) = $event)),
                          label: "Adverse Parties",
                          rows: "1"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createVNode(LlTextarea, {
                          modelValue: formState.value.custom.relatedAdverse,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formState.value.custom.relatedAdverse) = $event)),
                          label: "Related Adverse Entities",
                          rows: "1"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(LlTextarea, {
                          modelValue: formState.value.custom.relatedClients,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formState.value.custom.relatedClients) = $event)),
                          label: "Related Client Entities",
                          rows: "1"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createVNode(LlTextarea, {
                          modelValue: formState.value.custom.opposingCounsel,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formState.value.custom.opposingCounsel) = $event)),
                          label: "Opposing Counsel(s)",
                          rows: "1"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("div", _hoisted_27, [
                      _createVNode(LlTextarea, {
                        modelValue: formState.value.description,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formState.value.description) = $event)),
                        label: "Notes",
                        rows: "4"
                      }, null, 8, ["modelValue"])
                    ]),
                    (_unref(me).permissions && _unref(me).permissions.matters && _unref(me).permissions.matters.billingInstructions)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                          _createVNode(LlTextarea, {
                            modelValue: formState.value.custom.instructions,
                            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formState.value.custom.instructions) = $event)),
                            label: "Billing Instructions",
                            rows: "4"
                          }, null, 8, ["modelValue"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                (showOriginationSettings.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                      _cache[28] || (_cache[28] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Origination Settings ", -1)),
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          _createVNode(LlSelect, {
                            modelValue: formState.value.billing.originationStepDownStatus,
                            "onUpdate:modelValue": [
                              _cache[13] || (_cache[13] = ($event: any) => ((formState.value.billing.originationStepDownStatus) = $event)),
                              originationStepDownChange
                            ],
                            items: originationStepDownOptions,
                            "item-title": "label",
                            "item-value": "id",
                            label: "Step-down Status",
                            "hide-details": ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _createElementVNode("div", _hoisted_32, [
                          _createVNode(LlTextField, {
                            modelValue: formState.value.billing.originationStepDownPeriodInMonths,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formState.value.billing.originationStepDownPeriodInMonths) = $event)),
                            modelModifiers: { number: true },
                            label: "Step-down Duration",
                            type: "number",
                            disabled: formState.value.billing.originationStepDownDisabled,
                            "error-messages": 
                  isInvalidStepDownPeriod.value
                    ? ['Step-down Duration must be a positive number']
                    : []
                ,
                            suffix: "Months"
                          }, null, 8, ["modelValue", "disabled", "error-messages"])
                        ]),
                        _createElementVNode("div", _hoisted_33, [
                          _createVNode(LlTextField, {
                            modelValue: formState.value.billing.originationStepDownStart,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formState.value.billing.originationStepDownStart) = $event)),
                            label: "Step-down Start Date",
                            type: "date",
                            disabled: formState.value.billing.originationStepDownDisabled,
                            "error-messages": 
                  !formState.value.billing.originationStepDownDisabled &&
                  isInvalidDate(formState.value.billing.originationStepDownStart)
                    ? ['Please enter a valid date']
                    : []
                
                          }, null, 8, ["modelValue", "disabled", "error-messages"])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (editCustomFields.value.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                      _cache[29] || (_cache[29] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Custom Field ", -1)),
                      _createElementVNode("div", _hoisted_35, [
                        _createElementVNode("table", null, [
                          _createElementVNode("tbody", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(editCustomFields.value, (customField) => {
                              return (_openBlock(), _createElementBlock("tr", {
                                key: customField.id
                              }, [
                                _createElementVNode("td", null, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(customField.label), 1)
                                ]),
                                _createElementVNode("td", null, [
                                  (customField.type === 'enum')
                                    ? (_openBlock(), _createBlock(LlSelect, {
                                        key: 0,
                                        modelValue: customField.enumValueId,
                                        "onUpdate:modelValue": ($event: any) => ((customField.enumValueId) = $event),
                                        items: customField.enumOptions,
                                        "item-title": "label",
                                        "item-value": "id",
                                        "return-object": false,
                                        disabled: !enable.editMatterInfo,
                                        clearable: "",
                                        placeholder: "Select...",
                                        "hide-details": ""
                                      }, null, 8, ["modelValue", "onUpdate:modelValue", "items", "disabled"]))
                                    : (customField.type === 'number')
                                      ? (_openBlock(), _createBlock(LlTextField, {
                                          key: 1,
                                          modelValue: customField.numberValue,
                                          "onUpdate:modelValue": ($event: any) => ((customField.numberValue) = $event),
                                          modelModifiers: { number: true },
                                          type: "number",
                                          step: "any",
                                          disabled: !enable.editMatterInfo,
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                      : (_openBlock(), _createBlock(LlTextField, {
                                          key: 2,
                                          modelValue: customField.textValue,
                                          "onUpdate:modelValue": ($event: any) => ((customField.textValue) = $event),
                                          disabled: !enable.editMatterInfo,
                                          "hide-details": ""
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "disabled"]))
                                ])
                              ]))
                            }), 128))
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (isContingency.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", _hoisted_39, [
                          _cache[30] || (_cache[30] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Contingency Details ", -1)),
                          _createElementVNode("div", null, [
                            _createVNode(LlSelect, {
                              modelValue: formState.value.caseStatus,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formState.value.caseStatus) = $event)),
                              items: caseStatusOptions.value,
                              "item-title": "label",
                              "item-value": "label",
                              "return-object": false,
                              label: "Case Status",
                              placeholder: "Select Case Status",
                              clearable: "",
                              "hide-details": "",
                              "data-cy": "contingency-case-status-select"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _createElementVNode("div", _hoisted_40, [
                            _createVNode(LlSelect, {
                              modelValue: formState.value.marketingSource,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formState.value.marketingSource) = $event)),
                              items: marketingSourceOptions.value,
                              "item-title": "label",
                              "item-value": "label",
                              "return-object": false,
                              label: "Marketing Source",
                              placeholder: "Select Marketing Source",
                              clearable: "",
                              "hide-details": "",
                              "data-cy": "contingency-marketing-source-select"
                            }, null, 8, ["modelValue", "items"])
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.expectedSettlementAmount,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formState.value.expectedSettlementAmount) = $event)),
                              modelModifiers: { number: true },
                              label: "Expected Settlement Amount",
                              type: "number",
                              step: "0.01",
                              prefix: "$",
                              placeholder: "0.00",
                              "error-messages": 
                    isInvalidAmount(formState.value.expectedSettlementAmount)
                      ? ['Amount cannot be negative']
                      : []
                  ,
                              "data-cy": "contingency-expected-settlement-amount-input"
                            }, null, 8, ["modelValue", "error-messages"])
                          ]),
                          _createElementVNode("div", _hoisted_42, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.expectedCaseCosts,
                              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formState.value.expectedCaseCosts) = $event)),
                              modelModifiers: { number: true },
                              label: "Expected Case Costs",
                              type: "number",
                              step: "0.01",
                              prefix: "$",
                              placeholder: "0.00",
                              "error-messages": 
                    isInvalidAmount(formState.value.expectedCaseCosts)
                      ? ['Amount cannot be negative']
                      : []
                  ,
                              "data-cy": "contingency-expected-case-costs-input"
                            }, null, 8, ["modelValue", "error-messages"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_43, [
                          _cache[31] || (_cache[31] = _createElementVNode("h3", { class: "text-lg font-medium leading-6 text-gray-700" }, " Settlement Dates ", -1)),
                          _createElementVNode("div", null, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.expectedSettlementDate,
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formState.value.expectedSettlementDate) = $event)),
                              label: "Expected Settlement Date",
                              type: "date",
                              "error-messages": 
                    isInvalidDate(formState.value.expectedSettlementDate)
                      ? ['Please enter a valid date']
                      : []
                  ,
                              "data-cy": "contingency-expected-settlement-date-input"
                            }, null, 8, ["modelValue", "error-messages"])
                          ]),
                          _createElementVNode("div", _hoisted_44, [
                            _createVNode(LlTextField, {
                              modelValue: formState.value.settlementDate,
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formState.value.settlementDate) = $event)),
                              label: "Settlement Date",
                              type: "date",
                              "error-messages": 
                    isInvalidDate(formState.value.settlementDate)
                      ? ['Please enter a valid date']
                      : []
                  ,
                              "data-cy": "contingency-settlement-date-input"
                            }, null, 8, ["modelValue", "error-messages"])
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 512)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_45, [
          _createElementVNode("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createElementVNode("div", _hoisted_48, [
                _cache[37] || (_cache[37] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Internal", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[32] || (_cache[32] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Date Opened")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_49, _toDisplayString(formatDateDisplay(matter.value.opened)), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[33] || (_cache[33] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "State")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_50, _toDisplayString(matter.value.active ? 'Open' : 'Archived'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[34] || (_cache[34] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Practice Area")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_51, _toDisplayString(matter.value.matterTag ? matter.value.matterTag.label : '-'), 1)
                      ])
                    ]),
                    (labels.value.custom1)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_52, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_53, _toDisplayString(labels.value.custom1), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_54, _toDisplayString(customField('department')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (labels.value.custom2)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_55, [
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_56, _toDisplayString(labels.value.custom2), 1)
                          ]),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_57, _toDisplayString(customField('practiceArea')), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _cache[35] || (_cache[35] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Referral Source(s)")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_58, _toDisplayString(customField('referralSource')), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[36] || (_cache[36] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Created By")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_59, _toDisplayString(matter.value.createdBy || '-'), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_60, [
                _cache[42] || (_cache[42] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Conflict Information", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[38] || (_cache[38] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Adverse")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_61, _toDisplayString(customField('adverse')), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[39] || (_cache[39] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Opposing")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_62, _toDisplayString(matter.value.custom && matter.value.custom.opposingCounsel), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[40] || (_cache[40] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Clients")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_63, _toDisplayString(customField('relatedClients')), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[41] || (_cache[41] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "mr-2 text-xs text-gray-400" }, "Related")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_64, _toDisplayString(customField('relatedAdverse')), 1)
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_65, [
                _cache[43] || (_cache[43] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Notes", -1)),
                _createElementVNode("div", _hoisted_66, _toDisplayString(matter.value.description || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_67, [
                _cache[45] || (_cache[45] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Billing Instructions", -1)),
                (_unref(me).permissions && _unref(me).permissions.matters && _unref(me).permissions.matters.billingInstructions)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_68, _toDisplayString(customField('instructions')), 1))
                  : (_openBlock(), _createElementBlock("div", _hoisted_69, [...(_cache[44] || (_cache[44] = [
                      _createElementVNode("i", null, "hidden", -1)
                    ]))]))
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createVNode(LlSecondaryButton, {
                onClick: startEditing,
                disabled: uiState.saving,
                class: "block mb-8 ml-auto",
                "data-cy": "matter-info-edit-button"
              }, {
                default: _withCtx(() => [...(_cache[46] || (_cache[46] = [
                  _createTextVNode(" Edit ", -1)
                ]))]),
                _: 1
              }, 8, ["disabled"]),
              (enable.delete)
                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 0,
                    onClick: confirmDelete,
                    disabled: uiState.saving,
                    class: "block mb-2 ml-auto",
                    "data-cy": "matter-info-delete-button"
                  }, {
                    default: _withCtx(() => [...(_cache[47] || (_cache[47] = [
                      _createTextVNode(" Delete ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (enable.archive)
                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 1,
                    onClick: confirmArchive,
                    disabled: uiState.saving,
                    class: "block mb-2 ml-auto",
                    "data-cy": "matter-info-archive-button"
                  }, {
                    default: _withCtx(() => [...(_cache[48] || (_cache[48] = [
                      _createTextVNode(" Archive ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true),
              (enable.activate)
                ? (_openBlock(), _createBlock(LlSecondaryButton, {
                    key: 2,
                    onClick: restore,
                    disabled: uiState.saving,
                    class: "block mb-2 ml-auto",
                    "data-cy": "matter-info-activate-button"
                  }, {
                    default: _withCtx(() => [...(_cache[49] || (_cache[49] = [
                      _createTextVNode(" Activate ", -1)
                    ]))]),
                    _: 1
                  }, 8, ["disabled"]))
                : _createCommentVNode("", true)
            ])
          ]),
          (showOriginationSettings.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                _cache[54] || (_cache[54] = _createElementVNode("h3", { class: "text-lg font-bold" }, "Origination Settings", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[50] || (_cache[50] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "my-1 text-xs text-gray-600" }, "Step-down Status")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_72, _toDisplayString(matter.value.billing && matter.value.billing.originationStepDownDisabled
                    ? 'Disabled'
                    : 'Enabled'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[51] || (_cache[51] = _createElementVNode("td", null, [
                        _createElementVNode("div", { class: "my-1 text-xs text-gray-600" }, "Step-down Start Date")
                      ], -1)),
                      _createElementVNode("td", null, [
                        _createElementVNode("div", _hoisted_73, _toDisplayString(formatDateDisplay(
                    matter.value.billing && matter.value.billing.originationStepDownStart,
                  )), 1)
                      ])
                    ]),
                    (matter.value.billing && !matter.value.billing.originationStepDownDisabled)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_74, [
                          _cache[52] || (_cache[52] = _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "my-1 text-xs text-gray-600" }, "Step-down Duration")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_75, _toDisplayString((matter.value.billing &&
                    matter.value.billing.originationStepDownPeriodInMonths) || '-'), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    (matter.value.billing && !matter.value.billing.originationStepDownDisabled)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_76, [
                          _cache[53] || (_cache[53] = _createElementVNode("td", null, [
                            _createElementVNode("div", { class: "my-1 text-xs text-gray-600" }, "Step-down End Date")
                          ], -1)),
                          _createElementVNode("td", null, [
                            _createElementVNode("div", _hoisted_77, _toDisplayString(formatDateDisplay(matter.value.originationStepDownDate)), 1)
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (customFields.value.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_78, [
                _cache[55] || (_cache[55] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Custom Field", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customFields.value, (cf) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: cf.id
                      }, [
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_79, _toDisplayString(cf.label), 1)
                        ]),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", _hoisted_80, _toDisplayString(cf.value != null && cf.value !== '' ? cf.value : '-'), 1)
                        ])
                      ]))
                    }), 128))
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (isContingency.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_81, [
                _cache[62] || (_cache[62] = _createElementVNode("div", { class: "text-sm font-semibold" }, "Contingency Details", -1)),
                _createElementVNode("table", null, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _cache[56] || (_cache[56] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Case Status")
                      ], -1)),
                      _createElementVNode("td", _hoisted_82, [
                        _createElementVNode("div", _hoisted_83, _toDisplayString(_unref(getCaseStatusLabel)(matter.value.caseStatus) || '—'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[57] || (_cache[57] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Marketing Source")
                      ], -1)),
                      _createElementVNode("td", _hoisted_84, [
                        _createElementVNode("div", _hoisted_85, _toDisplayString(_unref(getMarketingSourceLabel)(matter.value.marketingSource) || '—'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[58] || (_cache[58] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Expected Settlement Date")
                      ], -1)),
                      _createElementVNode("td", _hoisted_86, [
                        _createElementVNode("div", _hoisted_87, _toDisplayString(matter.value.expectedSettlementDate
                    ? formatDateDisplay(matter.value.expectedSettlementDate)
                    : '—'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[59] || (_cache[59] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Expected Settlement Amount")
                      ], -1)),
                      _createElementVNode("td", _hoisted_88, [
                        _createElementVNode("div", _hoisted_89, _toDisplayString(matter.value.expectedSettlementAmount
                    ? formatCurrency(matter.value.expectedSettlementAmount)
                    : '—'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[60] || (_cache[60] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Expected Case Costs")
                      ], -1)),
                      _createElementVNode("td", _hoisted_90, [
                        _createElementVNode("div", _hoisted_91, _toDisplayString(matter.value.expectedCaseCosts != null
                    ? formatCurrency(matter.value.expectedCaseCosts)
                    : '—'), 1)
                      ])
                    ]),
                    _createElementVNode("tr", null, [
                      _cache[61] || (_cache[61] = _createElementVNode("td", { class: "pr-6 py-1" }, [
                        _createElementVNode("div", { class: "text-xs text-gray-400" }, "Settlement Date")
                      ], -1)),
                      _createElementVNode("td", _hoisted_92, [
                        _createElementVNode("div", _hoisted_93, _toDisplayString(matter.value.settlementDate
                    ? formatDateDisplay(matter.value.settlementDate)
                    : '—'), 1)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode(LlConfirmationDialog, {
            ref_key: "confirmDialogRef",
            ref: confirmDialogRef,
            title: confirmDialog.title,
            message: confirmDialog.message,
            "confirm-text": confirmDialog.confirmText,
            "toggle-text": "Cancel",
            "preserve-newlines": ""
          }, null, 8, ["title", "message", "confirm-text"])
        ]))
}
}

})